'use strict'

var markdownLineEnding = require('../character/markdown-line-ending.js')

var hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}

function tokenizeHardBreakEscape(effects, ok, nok) {
  return start

  function start(code) {
    effects.enter('hardBreakEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    return open
  }

  function open(code) {
    if (markdownLineEnding(code)) {
      effects.exit('escapeMarker')
      effects.exit('hardBreakEscape')
      return ok(code)
    }

    return nok(code)
  }
}

module.exports = hardBreakEscape



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/tokenize/hard-break-escape.js
// module id = 1508
// module chunks = 0